function deepTrim(object) {
  if (typeof object === 'string') {
    return object.trim();
  }
  if (typeof object === 'object') {
    for (const key in object) {
      object[key] = deepTrim(object[key]);
    }
  }

  return object;
}

export default deepTrim;



// WEBPACK FOOTER //
// ./src/utils/converters/deepTrim.js